/**
 * @flow
 */
import { Box, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group'; // ES6

type Props = {
  option: Object,
};

const AnswerBar = ({ option: { label, pct } }: Props) => {
  const nodeRef = useRef(null);
  const [appeared, setAppeared] = useState(false);
  return (
    <Box
      sx={{
        height: 40,
        bgcolor: 'primary.ultraLight',
        borderRadius: '5px',
        flexGrow: 1,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        my: '5px',
      }}
    >
      <CSSTransition nodeRef={nodeRef} in appear timeout={0} onEntered={() => setAppeared(true)}>
        <Box
          ref={nodeRef}
          sx={theme => ({
            position: 'absolute',
            width: appeared ? `${pct}%` : 0,
            height: '100%',
            bgcolor: theme.palette.primary.light4,
            transition: 'width 0.5s ease-out 0.25s',
            borderRadius: '2px',
          })}
        />
      </CSSTransition>
      <Typography sx={{ position: 'relative', p: '10px' }}>{label}</Typography>
    </Box>
  );
};

export default AnswerBar;
